import { Component } from '@angular/core';

@Component({
  selector: 'am-payment-method-modal',
  templateUrl: './payment-method-modal.component.html',
  styleUrls: ['./payment-method-modal.component.scss'],
})
export class PaymentMethodModalComponent {
  constructor() {}
}
